import { Component, Input } from '@angular/core';
import { NbDialogRef, NbGlobalPhysicalPosition, NbIconConfig, NbToastrService } from '@nebular/theme';
import { ConfirmModalComponent } from '../../modals/confirm-modal.component';

import { LanguageService, GameService, CharacterService } from '../../../_services/index';

import { trigger, transition, animate, style } from '@angular/animations';
import { NbDialogService } from '@nebular/theme';

import { diffChars }  from '../../template-update/character';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'ngx-character-changes-modal',
    templateUrl: 'character-changes-modal.component.html',
    styleUrls: ['character-changes-modal.component.scss'],
    animations: [
        trigger('slideInOut', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('200ms', style({ opacity: 1 })),
            ]),
            transition(':leave', [
                animate('100ms', style({ opacity: 0 })),
            ])
        ])
    ],
    standalone: false
})
export class CharacterChangesModalComponent {

  positions = NbGlobalPhysicalPosition;
  gameVisibly = [];
  //loadData = false;
  templateCharacters;
  templateId = '';
  games;
  //missions = []
  //changeExist = true
  loading = false;
  gamesChanges=[]
  currentLang = '';

  @Input() data;

  constructor(protected ref: NbDialogRef<CharacterChangesModalComponent>,
    public characterService: CharacterService,
    public languageService: LanguageService,
    private toastrService: NbToastrService,
    private dialogService: NbDialogService,
    private gameService: GameService) {
  }

  ngOnInit(){
    this.checkForChanges(this.data);
  }

  async checkForChanges(data){
    this.loading = true;
    this.templateId = data.templateId;
    this.currentLang = data.currentLang;
    this.games = data.games;
    this.templateCharacters = data.templateCharacters
    
    let start = new Date().getTime();
    console.log('start-list template missions');
    let gamesChanges = [];

    console.log('start-list all games characters');
    for (let i = 0; i < this.games.length; i++) {
      this.games[i].characters = await firstValueFrom(this.characterService.listCharacters(`games/${this.games[i].id}/characters`));
    } 
    console.log('Assign characters to games');
    for(let i = 0; i < this.templateCharacters.length; i++){
      for(let j = 0; j < this.games.length; j++){
        //verification from template to game
        let character;
        character = this.games[j].characters.find(char => char.id == this.templateCharacters[i].id)
        if(!character){
          //Template object does not exist in the game
          let index;
          index = gamesChanges.findIndex(game => game.gameId == this.games[j].id);
          if(index >= 0){
            this.pushGameChange(gamesChanges, index, this.templateCharacters[i], null);
          }else{
            this.pushNewChange(gamesChanges, this.games[j], this.templateCharacters[i], null);
          }
        } else {
          //Template object exist in the game
          let index
          let params = ['labels', 'description', 'pictureLastUpdate', 'voiceId']
          for(let k = 0; k < params.length; k++) {
            const param = params[k];
            let isCharacterDiff:boolean
            if(param == 'pictureLastUpdate' || param == 'voiceId'){
              isCharacterDiff = character[param] != this.templateCharacters[i][param]
            }else{
              isCharacterDiff = character[param][this.languageService.currentLang] != this.templateCharacters[i][param][this.languageService.currentLang]
            }
            if(isCharacterDiff){
              index = gamesChanges.findIndex(change => change.gameId == character.gameId);
              if(index >= 0){
                this.pushGameChange(gamesChanges, index, this.templateCharacters[i], character)
              }else{
                this.pushNewChange(gamesChanges, this.games[j], this.templateCharacters[i], character)
              }
            }
          }
        }
      }  
    }
    //verification from game to template
    for(let game of this.games){
      for(let characters of game.characters){
        let charGameTemplate = this.templateCharacters.find(obj=> obj.id == characters.id)
        if(!charGameTemplate){
          let index = gamesChanges.findIndex(gameChange => gameChange.gameId == game.id);
          if(index >= 0){
            this.pushGameChange(gamesChanges, index, null, characters)
          }else {
            this.pushNewChange(gamesChanges, game, null, characters)
          }
        }
      }
    }
    let stop = new Date().getTime();
    console.log('Data treatment took '+((stop-start)/1000)+'sec');
    this.games = this.games;
    this.gamesChanges = gamesChanges;
    this.loading = false;
  }

  getGameById(gameId){
    let game =  this.games.find(game => game.id == gameId);
    return game;
  }

  pushGameChange(gamesChanges, index, templateCharacters, character){    
    gamesChanges[index].changes.push({
      templateId: this.templateId,
      template: templateCharacters ? templateCharacters : {labels: {}, description: {}, pictureUrl: ''},
      characterGame: character,
    })
  }

  pushNewChange(gamesChanges, games, templateCharacters, character){
    gamesChanges.push({
      gameId: games.id,
      name: games.name,
      changes:[{
        templateId: this.templateId,
        template: templateCharacters ? templateCharacters : {labels: {}, description: {}, pictureUrl: ''},
        characterGame: character,
      }]
    })
  }

  deleteCharacter(character, i, j){
    this.dialogService.open(ConfirmModalComponent, { 
      context: {
        title: 'Confirmation',
        message: `Do you want to delete character '`+character.labels[this.languageService.currentLang]+`'?`
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(async res => {
      console.log('Dialog returns:'+res);
      if(res){
        console.log('Delete character:'+character.collectionPath);
        //comment for tests
        //await this.characterService.deleteCharacter(character);
        if(this.gamesChanges[i].changes.length == 1){
          this.gamesChanges.splice(i, 1);
        }
        else{
          this.gamesChanges[i].changes.splice(j, 1);
        }
      }
    });
  }

  close() {
    this.ref.close();
  }

  getDiffAttributes(from, to, param){
    if(from && to){
      let diff = diffChars(from, to , {})
      if( diff.length > 1 ){
        return this.setNewColoredAttribut(diff, param)
      } else return to
    } else if (!from && to){
      return '<span class="added">'+to + '</span>'
    } else return to
  }
  
  ngAfterViewChecked(){
    const added = document.querySelectorAll<HTMLElement>('.added') 
    added.forEach(function(item) {
      item.style.color = '#1dc864',
      item.style.fontSize = '16px';
    });
    const removed = document.querySelectorAll<HTMLElement>('.removed')
    removed.forEach(function(item) {
      item.style.color = 'red';
      item.style.fontSize = '16px';
    }); 
  }

  setNewColoredAttribut(diff, param){
    let att = ''
    for (let i = 0; i < diff.length; i++) {
      const element = diff[i];
      if(!element.removed && !element.added){
        att += element.value 
      }
      if(param === 'to'){
        if(!element.removed && element.added){
          att += '<span class="added">'+ element.value + '</span>'
        }
      }else{
        if(!element.removed && element.added){
          att += '<span class="removed">'+ element.value + '</span>'
        }
      }
    }
    return att
  }
  
  async applyChanges(game, characterTemplate, characterGame, i, j, n){
    let result;
    let error;

    if(!game.hasCharacters){
      await this.gameService.updateGame(game.gameId, {hasCharacters: true})
    }
    if(!characterGame) {
      console.log('Template character: '+JSON.stringify(characterTemplate));

      let data:any = {
        collectionPath: `games/${game.gameId}/characters`,
        gameId            : game.gameId,
        id                : characterTemplate.id,
        orderNum          : characterTemplate.orderNum,
        labels            : characterTemplate.labels,
        description       : characterTemplate.description,
        moods             : characterTemplate.moods
      }
      if(characterTemplate.filePath){
        data.lastUpdate = characterTemplate.lastUpdate;
        data.filePath = characterTemplate.filePath;
        data.fileURL = characterTemplate.fileURL;
      }
      
      console.log('Create character: '+JSON.stringify(data));
      this.characterService.setCharacter(data).then(value => {
        result = value
        this.changeShowToast(value, n, 'Add')
        if(this.gamesChanges[i].changes.length == 1){
          this.gamesChanges.splice(i, 1);
        }
        else{
          this.gamesChanges[i].changes.splice(j, 1);
        }
      }, err => {
        error = err
        console.log('error :',error)
        this.changeShowToast('error', n, 'Add')
      });
    }else{
      let data:any = {
        collectionPath: `games/${game.gameId}/characters`,
        orderNum          : characterTemplate.orderNum,
        labels            : characterTemplate.labels,
        description       : characterTemplate.description,
        moods             : characterTemplate.moods
      }
      
      if(characterTemplate.filePath){
        data.lastUpdate = characterTemplate.lastUpdate;
        data.filePath = characterTemplate.filePath;
        data.fileURL = characterTemplate.fileURL;
      }

      this.characterService.updateCharacter(characterGame, data).then(value => {
        result = value
        this.changeShowToast(value, n, 'Apply changes')
        if(this.gamesChanges[i].changes.length == 1) this.gamesChanges.splice(i, 1)
        else this.gamesChanges[i].changes.splice(j, 1)
      }, err => {
        error = err
        this.changeShowToast('error', n, 'Apply changes')
        console.log('error', error)
      });
    }
  }

  changeShowToast(type, n , action){
    if(n==0){
      if(type == 'error') this.showToast('Error', 'danger', `${action} characters failed`, 'close-outline')
      else this.showToast('Success', 'success', `Character successfully ${action}ed on game`, 'done-all-outline')
      
    }else if(n == this.gamesChanges.length){
      if(type == 'error') this.showToast('Error', 'danger', `${action} characters failed`, 'close-outline')
      else this.showToast('Success', 'success', `Character successfully ${action}ed on game`, 'done-all-outline')
    }
  }

  showToast(type,status ,text, iconName) {
    const icon: NbIconConfig = { icon: iconName, pack: 'eva' };
    let duration = 5000
    let position = this.positions.TOP_RIGHT
    this.toastrService.show(type , text, { position, status, duration,icon });
  }

  applyAllChanges(){//!game.hasCharacters
    this.dialogService.open(ConfirmModalComponent, { 
      context: {
        title: 'Confirmation',
        message: `Are you sure you want apply all changes?`
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(async res => {
      console.log('Dialog returns:'+res);
      if(res){
        for (let i = this.gamesChanges.length -1; i >= 0; i--) {
          const game = this.gamesChanges[i].changes;
          for (let j = game.length -1; j >= 0; j--) {
            const change = game[j];
            if( (this.gamesChanges.length - 1) == j && (game.length - 1) == j ){
              if(change.template?.id){
                await this.applyChanges(game, change.template, change.characterGame, i, j, 0);
              }
              else{
                await this.deleteCharacter(change.characterGame, i ,j);
              }
            } else{
              if(change.template?.id){
                await this.applyChanges(game, change.template, change.characterGame, i, j, this.gamesChanges.length);
              }
              else{
                await this.deleteCharacter(change.characterGame, i ,j);
              }
            }
          }
        }
      }
    });
  }

  toggleShowDetailGame(index) {
    this.gameVisibly[index] = this.gameVisibly[index]? !this.gameVisibly[index] : true;
  }
}